import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import { Link } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css'; 
import orgatriit from "../Db/orgatroit.png";

export default function Footer_Ui() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <footer className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white shadow-xl">
      <div className="max-w-screen-xl px-4 pt-16 pb-6 mx-auto sm:px-6 lg:px-8 lg:pt-24">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-4" data-aos="fade-up">
          {/* Logo and social links */}
          <div>
            <div className="flex justify-center text-white sm:justify-start" data-aos="zoom-in">
              <img src={orgatriit} alt='Orgatroit' className='footer-logo'></img>
            </div>

            <p className="max-w-md mx-auto mt-6 leading-relaxed text-center text-gray-300 sm:max-w-xs sm:mx-0 sm:text-left" data-aos="fade-up">
              We deliver innovative solutions for your business with a focus on user experience and technology. Stay connected with us.
            </p>

            <ul className="flex justify-center gap-6 mt-8 md:gap-8 sm:justify-start" data-aos="fade-right">
              <li>
                <a
                  href="https://facebook.com"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="text-white transition hover:text-gray-400"
                >
                  <span className="sr-only">Facebook</span>
                  <i className="fab fa-facebook-f w-6 h-6"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="text-white transition hover:text-gray-400"
                >
                  <span className="sr-only">Twitter</span>
                  <i className="fab fa-twitter w-6 h-6"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://linkedin.com"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="text-white transition hover:text-gray-400"
                >
                  <span className="sr-only">LinkedIn</span>
                  <i className="fab fa-linkedin-in w-6 h-6"></i>
                </a>
              </li>
            </ul>
          </div>

          {/* Sections: About Us, Services, Contact Us, Features */}
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:col-span-3 md:grid-cols-4" data-aos="fade-left">
            
            {/* About Us Section */}
            <div className="text-center sm:text-left">
              <p className="text-lg font-medium text-white" data-aos="zoom-in">About Us</p>
              <nav className="mt-8" data-aos="fade-up">
                <ul className="space-y-4 text-sm">
                  <li>
                    <Link className="text-white transition hover:text-gray-400" to="/about-us">
                      Company History
                    </Link>
                  </li>
                  <li>
                    <Link className="text-white transition hover:text-gray-400" to="/">
                      Leadership Team
                    </Link>
                  </li>
                  <li>
                    <Link className="text-white transition hover:text-gray-400" to="/">
                      Our Vision
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>

            {/* Services Section */}
            <div className="text-center sm:text-left">
              <p className="text-lg font-medium text-white" data-aos="zoom-in">Our Services</p>
              <nav className="mt-8" data-aos="fade-up">
                <ul className="space-y-4 text-sm">
                  <li>
                    <Link className="text-white transition hover:text-gray-400" to="/webdevelopment">
                      Web Development
                    </Link>
                  </li>
                  <li>
                    <Link className="text-white transition hover:text-gray-400" to="/uidesign">
                      UI/UX Design
                    </Link>
                  </li>
                  <li>
                    <Link className="text-white transition hover:text-gray-400" to="/cloud-solution">
                      Cloud Solutions
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>

            {/* Features Section (New) */}
            <div className="text-center sm:text-left">
              <p className="text-lg font-medium text-white" data-aos="zoom-in">Features</p>
              <nav className="mt-8" data-aos="fade-up">
                <ul className="space-y-4 text-sm">
                  <li>
                    <Link className="text-white transition hover:text-gray-400" to="/">
                      Artificial Intelligence
                    </Link>
                  </li>
                  <li>
                    <Link className="text-white transition hover:text-gray-400" to="/">
                      Machine Learning
                    </Link>
                  </li>
                  <li>
                    <Link className="text-white transition hover:text-gray-400" to="/">
                      Blockchain Technology
                    </Link>
                  </li>
                  <li>
                    <Link className="text-white transition hover:text-gray-400" to="/">
                      Internet of Things (IoT)
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>

            {/* Contact Us Section */}
            <div className="text-center sm:text-left">
              <p className="text-lg font-medium text-white" data-aos="zoom-in">Contact Us</p>
              <nav className="mt-8" data-aos="fade-up">
                <ul className="space-y-4 text-sm">
                  <li>
                    <Link className="text-white transition hover:text-gray-400" to="/">
                      Email Us
                    </Link>
                  </li>
                  <li>
                    <Link className="text-white transition hover:text-gray-400" to="/">
                      Find a Location
                    </Link>
                  </li>
                  <li>
                    <Link className="text-white transition hover:text-gray-400" to="/">
                      Schedule a Meeting
                    </Link>
                  </li>
                  <li>
                    <Link className="flex items-center group justify-center sm:justify-start gap-2" to="/">
                      <span className="text-white transition group-hover:text-white/75">Live Chat</span>
                      <span className="relative flex items-center justify-center w-3 h-3">
                        <span className="absolute inline-flex w-full h-full bg-teal-400 rounded-full opacity-75 animate-ping"></span>
                        <span className="relative inline-flex w-3 h-3 bg-teal-500 rounded-full"></span>
                      </span>
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

        {/* Footer Bottom Section */}
        <div className="pt-6 mt-12 border-t border-gray-500" data-aos="fade-up">
          <div className="text-center sm:flex sm:justify-between sm:text-left">
            <p className="text-sm text-gray-400">
              <span className="block sm:inline">All rights reserved.</span>
              <Link className="inline-block text-white underline transition hover:text-gray-400" to="/">
                Terms & Conditions
              </Link>
              <span>&middot;</span>
              <Link className="inline-block text-white underline transition hover:text-gray-400" to="/">
                Privacy Policy
              </Link>
            </p>

            <p className="mt-4 text-sm text-gray-500 sm:order-first sm:mt-0">
              &copy; 2024
              <span className="text-3xl ml-3 font-semibold text-white relative inline-block animate-heartbeat" data-aos="fade-right">
                OrgatroIT
                <span className="absolute ml-3 top-1 left-1 text-white blur-md opacity-60" data-aos="fade-right">
                  OrgatroIT
                </span>
              </span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
